import { Component, ViewChild} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VendorService } from 'src/app/services/vendorservice';
import { Vendor, VendorDropdownData } from '../../DTO/vendor';
import { ConnectionDetailsComponent } from '../../connection/connection-details/connection-details.component';

@Component({
  selector: 'app-vendor-update',
  templateUrl: './vendor-update.component.html',
  styleUrls: ['./vendor-update.component.css']
})
export class VendorUpdateComponent {

  isLoading: boolean = false;
  form: FormGroup;
  VendorName: FormControl;
  VendorId: number = 0;
  UseConnectionDetails: FormControl;
  vendorList: Vendor[] = [];
  vendor: Vendor = new Vendor();
  useOkta: boolean = false;
  
  isConnectionSuccessful = false;
  @ViewChild(ConnectionDetailsComponent) connectionDetailsComponent: ConnectionDetailsComponent;
  constructor(private vendorService: VendorService, private toastr:ToastrService,
    private router: Router, private route: ActivatedRoute) {
      this.route.paramMap.subscribe((params) => {
        this.vendor.VendorId = params.get('id');
      });
    }

  ngOnInit() {
    this.vendor.AuthType = "BASIC";
    this.createFormControls();
    this.createForm();
    this.loadVendorDetails();
  }

  createFormControls() {
    this.VendorName = new FormControl('', [Validators.required, Validators.maxLength(60)]);
    this.UseConnectionDetails = new FormControl(false);
  }

  createForm() {
    this.form = new FormGroup({
      VendorName: this.VendorName,
      UseConnectionDetails: this.UseConnectionDetails
    });
  }

  get errorMessageForVendorName(): string {
    const vendorform: FormControl = (this.form.get('VendorName') as FormControl);
    return vendorform.hasError('required') ?
      'Vendor name is required' :
      vendorform.hasError('maxlength') ?
      'Max length is 60 characters' :
      vendorform.hasError('duplicate') ?
      'Vendor already exists' :"" 
}

  clearVendorNameDuplicateValidation(){
    this.VendorName.setErrors({'duplicate': null});
    this.VendorName.updateValueAndValidity();
  }

  OnVendorChange(event:any) {
    this.clearVendorNameDuplicateValidation();
  }

  loadVendorDetails() {
    this.isLoading=true;
    this.vendor.AuthType = 'BASIC'; // default
    this.vendor = VendorDropdownData.vendorList.find(vendor => vendor.VendorId == this.vendor.VendorId);
    this.VendorName.setValue(this.vendor.VendorName);
    this.VendorId = Number(this.vendor.VendorId);
    this.isLoading=true;
    this.vendorService.getVendorDetails(this.vendor).subscribe(res=>{
    this.vendor = res;
    
      //this.connectionDetailsAttributeModel.toggleState = !!res.AuthType;
      if(res.AuthType !== "" && res.AuthType !== null){
          if (res.AuthType == "OKTA")
          {
            this.connectionDetailsComponent.useOkta = true;
          }
          else
          {
            this.connectionDetailsComponent.useOkta = false;
        }
          this.vendor.IsConnectivitySet = "true";
        }
        else
        {
          this.vendor.IsConnectivitySet = "false";
        }
      this.isLoading=false;
     },(error: any)=>{
          this.isLoading=false;
          this.toastr.error(error);
        });
      }
  
  submitForm(){
    if (this.form.valid) {
        this.connectionDetailsComponent.setModelAttributes();
        this.isLoading = true;
        this.vendor.VendorName = this.form.get('VendorName')?.value;

        // Check if OKTA is being used
        const useOkta = this.connectionDetailsComponent.useOkta;

        // Set OktaClientSecret value based on `useOkta`
        let oktaClientSecret = (useOkta && 
                                (!this.form.get('OktaClientSecret')?.value || this.form.get('OktaClientSecret')?.value.trim() == '')) 
                                ? this.vendor.HiddenClientSecret 
                                : "**********";
        
        let basicPassword = !useOkta ? (this.form.get('BasicPassword')?.value?.trim() ? this.form.get('BasicPassword')?.value : this.vendor.HiddenPassword) : "";

        if (!this.connectionDetailsComponent.panelOpenState) {
            this.vendor = new Vendor();
            this.vendor.VendorName = this.form.get('VendorName')?.value;
            this.vendor.VendorId = this.VendorId.toString();
            this.vendor.IsConnectivitySet = "false";
        } else {
            this.vendor.IsConnectivitySet = "true";
            if (!useOkta) {
              this.vendor.BasicPassword = this.connectionDetailsComponent.getBasicPassword();
              this.vendor.OktaClientSecret = "";
            } else {
              this.vendor.OktaClientSecret = this.vendor.OktaClientSecret?.trim() ? this.connectionDetailsComponent.getOktaClientSecret() : oktaClientSecret;
              this.vendor.BasicPassword = "";
            }
        }

        this.vendor.UpdatedBy = localStorage.getItem("loggedName");

        // Remove hidden fields before sending request
        let vendorPayload = { ...this.vendor };
        delete vendorPayload.HiddenPassword;
        delete vendorPayload.HiddenClientSecret;

        // **Update vendor details**
        this.vendorService.updateVendor(vendorPayload).subscribe(res => {
            this.isLoading = false;
            console.log(res.ResponseStatus);
            if (res.ResponseStatus == '1') {
                this.vendor.HiddenPassword = !useOkta ? basicPassword : "";
                this.vendor.HiddenClientSecret = oktaClientSecret;
                this.toastr.success('Vendor updated successfully');
                this.router.navigate(['searchvendor']);
            } else if (res.ResponseStatus == '0' && res.ResponseMessage !== '') {
                this.toastr.error(res.ResponseMessage);
            }
        }, (error: any) => {
            this.isLoading = false;
            if (Array.isArray(error)) {
                for (var err of error) {
                    if (err.ErrorMessage == 'Vendor Duplicate') {
                        this.VendorName.setErrors({ 'duplicate': true });
                    }
                }
            } else if (error == 'Vendor Duplicate') {
                this.VendorName.setErrors({ 'duplicate': true });
            } else {
                this.toastr.error(error);
            }
        });
    }
}

  onClickCancel(){
    this.router.navigate(['searchvendor']);
  }
}
